// Auto-DM Outreach feature entry — owned by the outreach feature.
// Routes: /outreach (campaigns), /outreach/new (builder; ?type=follow, ?preset=welcome),
// /outreach/:campaignId (detail), /outreach/:campaignId/edit (builder; ?step=message).
import { Send } from "lucide-react";
import { RequireIgAccount } from "../../lib/igAccount";
import type { FeatureModule } from "../registry";

const outreach: FeatureModule = {
  id: "outreach",
  nav: [{ to: "/outreach", label: "Campaigns", icon: Send, group: "growth", order: 10 }],
  routes: [
    {
      path: "/outreach",
      lazy: async () => {
        const { CampaignsPage } = await import("./CampaignsPage");
        return {
          Component: () => (
            <RequireIgAccount>
              <CampaignsPage />
            </RequireIgAccount>
          ),
        };
      },
    },
    {
      path: "/outreach/new",
      lazy: async () => {
        const { NewCampaignPage } = await import("./CampaignBuilder");
        return {
          Component: () => (
            <RequireIgAccount>
              <NewCampaignPage />
            </RequireIgAccount>
          ),
        };
      },
    },
    {
      path: "/outreach/:campaignId",
      lazy: async () => {
        const { CampaignPage } = await import("./CampaignPage");
        return {
          Component: () => (
            <RequireIgAccount>
              <CampaignPage />
            </RequireIgAccount>
          ),
        };
      },
    },
    {
      path: "/outreach/:campaignId/edit",
      lazy: async () => {
        const { EditCampaignPage } = await import("./CampaignBuilder");
        return {
          Component: () => (
            <RequireIgAccount>
              <EditCampaignPage />
            </RequireIgAccount>
          ),
        };
      },
    },
  ],
};

export default outreach;
